"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsolationError = exports.SecP256K1 = exports.Digest = exports.BIP39 = exports.BIP32 = void 0;
exports.BIP32 = __importStar(require("./bip32"));
exports.BIP39 = __importStar(require("./bip39"));
exports.Digest = __importStar(require("./digest"));
exports.SecP256K1 = __importStar(require("./secp256k1"));
class IsolationError extends Error {
    constructor(name) {
        super(`this key is isolated -- no ${name} for you!`);
    }
}
exports.IsolationError = IsolationError;
